(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["from-paper-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fp-home-slideshow')) {
    customElements.define('fp-home-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fp-slideshow__track');
        this.slides = [...this.querySelectorAll('.fp-slideshow__slide')];
        this.dots = [...this.querySelectorAll('.fp-slideshow__dot')];
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.step)), options));
        this.dots.forEach((dot, index) => dot.addEventListener('click', event => { event.preventDefault(); this.go(index); }, options));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.go(index);
        }, options);
        this.resize = new ResizeObserver(() => { this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }); });
        this.resize.observe(this.track);
        this.classList.add('is-ready');
        this.update();
      }
      go(index) {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
        this.dots.forEach((dot, index) => { if (index === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.slides.forEach((slide, index) => { slide.inert = index !== this.index; });
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
